import { call, put, takeLatest } from "@redux-saga/core/effects";
import { PROFILE_ACTION, responseProfileAction, errorProfileAction, responseUpdateProfileForUser, errorUpdateProfileForUser } from "./ProfileActionCreator";
import UserService from "../../Services/RestApiManager/UserManager/UserService";
import ProfileService from "../../Services/RestApiManager/ProfileManager/ProfileService";

export function* profileRequest(action) {
    try {
      const response = yield call(UserService.shared.userByIdRequest, action.data);
      yield put(responseProfileAction(response));
    } catch (error) {
      yield put(errorProfileAction(error));
    }
  }
  export function * updateProfileUserRequest (action) {
    try {
      console.log("Dispatching API Call with Data:", action.data); // Debugging
      const response = yield call(ProfileService.shared.updateprofileUserRequest, action.data);
      if(response){
      localStorage.setItem("userDetails", JSON.stringify(response));
      yield put(responseUpdateProfileForUser(response));
    } }catch (error) {
      yield put(errorUpdateProfileForUser(error));
    }
  }
  export function* profileWatcherSaga() {
    yield takeLatest(PROFILE_ACTION.REQUEST_PROFILE, profileRequest);
    yield takeLatest(PROFILE_ACTION.REQUEST_UPDATE_PROFILE_FOR_USER, updateProfileUserRequest)
  }